// import React from "react";
// import { Nav } from "shards-react";

// import SidebarNavItem from "./SidebarNavItem";
// import { Store } from "../../../flux";

// class SidebarNavItems extends React.Component {
//   constructor(props) {
//     super(props)

//     this.state = {
//       navItems: Store.getSidebarItems()
//     };

//     this.onChange = this.onChange.bind(this);
//   }

//   componentWillMount() {
//     Store.addChangeListener(this.onChange);
//   }

//   componentWillUnmount() {
//     Store.removeChangeListener(this.onChange);
//   }

//   onChange() {
//     this.setState({
//       ...this.state,
//       navItems: Store.getSidebarItems()
//     });
//   }

//   render() {
//     const { navItems: items } = this.state;
//     return (
//       <div className="nav-wrapper">
//         <Nav className="nav--no-borders flex-column">
//           {items.map((item, idx) => (
//             <SidebarNavItem key={idx} item={item} />
//           ))}
//         </Nav>
//       </div>
//     )
//   }
// }

// export default SidebarNavItems;

import React, { useState, useEffect } from "react";
import { Nav } from "shards-react";

import SidebarNavItem from "./SidebarNavItem";
import { Store } from "../../../flux";
import { useAuth } from "../../../providers/AuthProvider";

function SidebarNavItems() {
  const { userRole } = useAuth();
  const [navItems, setNavItems] = useState([]);

  useEffect(() => {
    let sideBarItems = Store.getSidebarItems();
    if (userRole === "admin") {
      setNavItems(sideBarItems.filter((item) => item.role === "admin"));
    } else if (userRole === "sub-admin") {
      setNavItems(sideBarItems.filter((item) => item.role === "sub-admin"));
    } else if (userRole === "specialTeacher") {
      setNavItems(sideBarItems.filter((item) => item.role === "teacher"));
    } else if (userRole === "classTeacher") {
      setNavItems(sideBarItems.filter((item) => item.role === "teacher"));
    } else if (userRole === "principalTeacher") {
      setNavItems(sideBarItems.filter((item) => item.role === "teacher"));
    } else if (userRole === "optician") {
      setNavItems(sideBarItems.filter((item) => item.role === "optician"));
    }
    // setNavItems(Store.getSidebarItems())
    // Store.addChangeListener(onChange);
    return Store.removeChangeListener(onChange);
  }, [Store]);

  const onChange = async () => {
    setNavItems(Store.getSidebarItems());
  };
  return (
    <div className="nav-wrapper">
      <Nav className="nav--no-borders flex-column">
        {navItems.map((item, idx) => (
          <SidebarNavItem key={idx} item={item} />
        ))}
      </Nav>
    </div>
  );
}

export default SidebarNavItems;
